import { css } from "@emotion/react";
import { colors } from "./variables";

export const globalStyles = css`
  html,
  body {
    height: 100%;
    overflow: hidden;

    #___gatsby,
    #gatsby-focus-wrapper,
    .slick-slider {
      height: 100%;
    }
    .slick-slider {
      -ms-touch-action: auto;
      touch-action: auto;
      div {
        height: 100%;
      }
    }
  }

  html {
    background-color: ${colors.black};
  }

  body {
    font-family: "Hiragino Kaku Gothic Pro", "Hiragino Kaku Gothic Pro W3",
      "Hiragino Kaku Gothic W3", "YuGothic", sans-serif;
    overscroll-behavior-y: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
    font-size: 1em;
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .slick-slide .view {
    outline: none;
  }

  img {
    pointer-events: none;
  }
`;
